import { useLearnerStorageChanges } from '../hooks/useLearnerStorageChanges';
import type { ReactNode } from 'react';

type AppShellProps = {
  children: ReactNode;
};

export function AppShell({ children }: AppShellProps) {
  useLearnerStorageChanges();
  return (
    <div className="liquid-glass-root text-slate-900">
      {children}
    </div>
  );
}
